import {useState} from 'react';

import IBatchResult from './IBatchResult';

import useBatchOperation from './useBatchOperation';

interface IExportRequest {
    result?: IBatchResult,
    isLoading: boolean,
    progress: number,
    // eslint-disable-next-line no-unused-vars
    submit: (data: object, onSuccess?: () => void) => Promise<void>,
    reset: () => void,
}

const useExportRequest = (path: string): IExportRequest => {
    const [result, setResult] = useState<IBatchResult | undefined>();
    const {trigger, isLoading, progress} = useBatchOperation();

    const submit = async(data: object, onSuccess?: () => void) => {
        await trigger(path, 'POST', data, (batchResult) => {
            setResult(batchResult);
            onSuccess?.();
        });
    };

    const reset = () => setResult(undefined);

    return {result, isLoading, progress, submit, reset};
};

export default useExportRequest;
